// Typelizer digest bc14ebbf507357aabd890beb5102fe63
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /daily */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/daily', {}, options),
    method: 'get',
  }),

  /** PATCH /daily */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/daily', {}, options),
    method: 'patch',
  }),
}
